import { getPremiumArticle } from '@vuePath/api/article';
import { recordPV } from '@vuePath/api/article';
/**
 * 縮放圖片
 */
let zooming_image = () => {
    new Zooming({
        bgColor: '#F8F7F6',
        customSize: '100%',
        onBeforeOpen: (target) => {
            target.classList.add('isZoom');
        },
        onClose: (target) => {
            target.classList.remove('isZoom');
        }
    }).listen('.feature_img_wrapper img.zoomin, .dnd-atom-wrapper.type-image img');
};

document.addEventListener('DOMContentLoaded', () => {

    const nid = document.getElementById('hidden_nid').value;
    const aid = document.getElementById('hidden_aid').value;
    const is_premium_article = document.getElementById('hidden_premium').value || '0';
    const aticle_line_share = document.getElementById('aticle_line_share');
    const ua = window.navigator.userAgent;
    let is_ua_mobile = false;

    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua)) {
        is_ua_mobile = true;
    }

    aticle_line_share.addEventListener('click', (e) => {
        let data_url = e.target.closest('.share_content').dataset.url;
        let data_title = e.target.closest('.share_content').dataset.title;
        if(is_ua_mobile) {
            let share_url = 'line://msg/text/《世界走走》' + data_title + '%0D%0A' + data_url;
            window.open(share_url);
        } else {
            let share_url = 'https://lineit.line.me/share/ui?url=' + data_url;
            window.open(share_url);
        }
    });

    if (is_premium_article === '1') {
        loadArticle(nid);
    } else {
        zooming_image();
    }

    copy_url();
    send_pv_record(nid, aid);
});

async function loadArticle(nid) {

    const content_block = document.getElementById('content_block');
    const first_p = document.getElementById('first_p_desc');

    await getPremiumArticle(nid).then((res) => {

        let data = res.data.data;
        let code = res.data.code || '';
        if (typeof data !== 'undefined' && code === '000') {
            let setInnerHTML = (elm, html) => {
                let slice = html.indexOf("</p>");
                first_p.innerHTML = html.substring(0, slice) + "</p>";
                elm.innerHTML = html.substring(slice + 4);
                Array.from(elm.querySelectorAll('script')).forEach( (old_script) => {
                    let new_script = document.createElement('script');
                    Array.from(old_script.attributes).forEach((attr) => {
                        return new_script.setAttribute(attr.name, attr.value);
                    });
                    new_script.appendChild(document.createTextNode(old_script.innerHTML));
                    old_script.parentNode.replaceChild(new_script, old_script);
                });
            };
            setInnerHTML(content_block, data[0]['article_premium_content']);
        }
        zooming_image();
    });
}

function copy_url() {

    var clipboard = new Clipboard('.share_content.copy_link');

    clipboard.on('success', function (e) {
        alert('成功將網址複製至剪貼簿!');
        e.clearSelection();
    });

    clipboard.on('error', function (e) {
        alert('Oops! 請重新整理再試試看!');
    });
}

async function send_pv_record(nid, aid) {

    await recordPV(nid, aid);
}
